import {
  LinkButton,
  TextHighlight,
  TextWeight,
  textStyleUtils
} from '@focaldata/cin-ui-components'
import React, { ReactNode } from 'react'
import useStyles from './styles'

interface Props {
  hasError?: boolean
  /** Replaced by the error line when `hasError`. */
  children: ReactNode
  onEdit?: () => void
  onRemove?: () => void
}

// Shared so a questionnaire question and an audience question present a rule identically.
const DisplayLogicSummaryBox: React.FC<Props> = ({
  hasError = false,
  children,
  onEdit,
  onRemove
}: Props) => {
  const { classes } = useStyles()
  const { classes: textClasses, cx: classNames } =
    textStyleUtils.useTextStyles()

  return (
    <div
      key="display-logic-header"
      className={classNames(
        'fd-grid',
        'fd-container',
        'fd-row',
        'fd-justify-content-between',
        classes.container,
        { [classes.error]: hasError }
      )}
      data-testid="display-logic-header"
    >
      <div className="fd-grid fd-container fd-item fd-xs-10 fd-column">
        <p
          className={classNames(
            textClasses.default,
            textClasses.weightSemiBold
          )}
        >
          Display this question
        </p>
        {hasError ? (
          <p className={classNames(textClasses.highlightError)}>
            Invalid display logic. Please add a source for display logic.
          </p>
        ) : (
          children
        )}
      </div>
      <div className="fd-grid fd-container fd-item fd-xs-2 fd-justify-content-flex-end fd-align-items-center">
        <div
          className={classNames(
            'fd-grid',
            'fd-item',
            'fd-xs-auto',
            classes.edit
          )}
        >
          <LinkButton
            highlight={TextHighlight.Background}
            weight={TextWeight.SemiBold}
            onClick={() => onEdit?.()}
          >
            Edit
          </LinkButton>
        </div>
        <div className="fd-grid fd-item fd-xs-auto">
          <LinkButton
            highlight={TextHighlight.Background}
            weight={TextWeight.SemiBold}
            onClick={() => onRemove?.()}
          >
            Remove
          </LinkButton>
        </div>
      </div>
    </div>
  )
}

export default DisplayLogicSummaryBox
